<template>
  <div>
    <div class="head">
      <img src="@/assets/myImg/1/chevron-back-outline.png" class="backicon" @click="closeaffect" />
      <span>受影响用户</span>
    </div>
    <div class="cent">
      <a-checkbox class="checkall" :checked="checkAll" @change="onCheckAllChange">全选</a-checkbox>
      <ul>
        <li v-for="(item, index) in dataList" :key="index">
          <span class="checkbox">
            <a-checkbox v-model="checkedList[index]" @change="onChange(item.id)"></a-checkbox>
          </span>
          <span class="nikename">{{ item.userNikeName }}</span>

          <span class="classno">
            分类编码：{{ item.classNo }}
            <img src="@/assets/myImg/1/copy-outline.png" class="copyicon" />
            <a @click="copyUrl(item.classNo)" style="color: rgba(27, 108, 232, 100)">复制</a>
          </span>
          <span class="address">地址：{{ item.address }}</span>
          <span class="appearance">水表编号{{ item.appearanceNo }}</span>
        </li>
      </ul>
    </div>
    <div class="button">
      <a-button style="margin-left: 3px" type="primary" @click="endmessages">发送短信</a-button>
      <a-button style="margin-left: 3px" type="primary" @click="SendSMSwithoneclick">一键发送短信</a-button>
    </div>
    <a-modal v-model="visible" title="提示" @ok="handleOk">
      <a-row>
        <a-col :span="15" style="height: 35px"> 请选择需要发送的人员: </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-checkbox v-model="isUser" @change="checkbox">受影响的用户</a-checkbox>
        </a-col>
        <a-col :span="12">
          <a-checkbox v-model="isWater" @change="checkbo">水司人员</a-checkbox>
        </a-col>
      </a-row>
    </a-modal>
    <a-modal
      v-model="visibles"
      title="批量发送短信"
      :width="800"
      @ok="SendSMSinbulkOk"
      @cancel="SendSMSinbulkCancelh"
      :confirmLoading="sendSMSLoading"
      :okButtonProps="{ props: { disabled: sendSMSLoading } }"
      style="z-index: 9999"
    >
      <a-form-model
        class="log-form"
        :model="SendSMSwith"
        ref="SendSMSwith"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }"
      >
        <div v-if="this.isWaterdt">
          <a-form-model-item label="" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <h3>通知受影响的用户</h3>
          </a-form-model-item>
          <a-form-model-item label="短信模板" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="principal">
            <a-select v-model="SendSMSwith.principal" @change="handleChange" allow-clear>
              <a-select-option v-for="item in userlist" :key="item.id">{{ item.templateName }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="短信内容" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <a-textarea disabled placeholder="请输入发给所选用户的短信" v-model="SendSMSwith.userDto.body" :rows="3" />
          </a-form-model-item>
        </div>

        <div v-if="this.isWaterdty">
          <a-form-model-item label="" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <h3>通知水司人员</h3>
          </a-form-model-item>

          <a-form-model-item label="请选择需要发送的人员" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
            <a-checkbox v-model="isEventAdmin" @change="checkboxisEvent">事件管理员</a-checkbox>
            <a-checkbox v-model="isEventPrincipal" @change="checkboisEvent">事件负责人 </a-checkbox>
          </a-form-model-item>
          <a-form-model-item label="短信模板" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="assistPersons">
            <a-select show-search v-model="SendSMSwith.assistPersons" @change="handleChanget" allow-clear>
              <a-select-option v-for="item in userlist" :key="item.id">{{ item.templateName }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="短信内容" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <a-textarea disabled placeholder="请输入发给所选用户的短信" v-model="SendSMSwith.waterDto.body" :rows="3" />
          </a-form-model-item>
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'

export default {
  data() {
    return {
      columns: [
        {
          title: '片区名称',
          dataIndex: 'zoneName'
        },
        {
          title: '分类编码',
          dataIndex: 'classNo'
        },
        {
          title: '水表编号',
          dataIndex: 'appearanceNo'
        },
        {
          title: '用户名称',
          dataIndex: 'userNikeName'
        },
        {
          title: '用户地址',
          dataIndex: 'address'
        },
        {
          title: '手机号',
          dataIndex: 'phone'
        },
        {
          title: '安装时间',
          dataIndex: 'installDate'
        },
        {
          title: '口径',
          dataIndex: 'caliber'
        },
        {
          title: '品牌',
          dataIndex: 'brand'
        },
        {
          title: '类型',
          dataIndex: 'type'
        },
        {
          title: '状态',
          dataIndex: 'status'
        },
        {
          title: '用户用水类型',
          dataIndex: 'waterBigStatus',
          scopedSlots: { customRender: 'waterBigStatus' }
        }
      ],
      queryUrl: 'pipe-network/gis_class_user_water_meters/page',
      dataList: [],
      dataListLoading: false,
      checkedList: [],
      indeterminate: true,
      checkAll: false,
      visible: false,
      isUser: true,
      isWater: true,
      isWaterdt: true,
      isWaterdty: true,
      visibles: false,
      sendSMSLoading: false,
      isEventAdmin: true,
      itemid: '',
      isEventPrincipal: true,
      SendSMSwith: {
        lineId: '',
        classNos: '',
        gisClassIds: [],
        isUser: true,
        isWater: true,
        principal: '',
        assistPersons: '',
        userDto: {
          id: '',
          body: ''
        },
        waterDto: {
          id: '',
          body: '',
          isEventAdmin: true,
          isEventPrincipal: true
        }
      },
      rules: {
        principal: [{ required: true, message: '请选择短信模板名称', trigger: 'change' }],
        assistPersons: [{ required: true, message: '请选择短信模板名称', trigger: 'change' }]
      },
      userlist: [],
      pagination: {
        current: 1,
        pageSize: 10000,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      exportFileName: '影响用户数据.xlsx',
      exportDataUrl: 'pipe-network/gis_class_user_water_meters/export',
      exportLoading: false,
      selectedRows: [],
      showTubeView: false,
      id: ''
    }
  },
  methods: {
    moment,
    SendSMSwithoneclick() {
      this.visible = true
    },
    checkbox(value) {
      this.SendSMSwith.isUser = value.target.checked
    },
    checkbo(value) {
      this.SendSMSwith.isWater = value.target.checked
    },
    handleOk() {
      if (this.SendSMSwith.isUser == true || this.SendSMSwith.isWater == true) {
        if (this.SendSMSwith.isUser == false) {
          this.isWaterdt = false
        } else {
          this.isWaterdt = true
        }
        if (this.SendSMSwith.isWater == false) {
          this.isWaterdty = false
        } else {
          this.isWaterdty = true
        }
        this.visibles = true
        this.$http.get('/pipe-network/api/v1/sms/templates/list').then((res) => {
          this.userlist = res.data
          console.log(res.data)
        })
      } else {
        return this.$message.info('请至少选择-种需要发送短信的人员！')
      }
    },
    filterOption(input, option) {
      return option.componentOptions
    },
    handleChanget(value) {
      ;(this.currentId = value),
        this.$http.get(`/pipe-network/api/v1/sms/templates/${this.currentId}`).then((res) => {
          this.SendSMSwith.waterDto.body = res.data.templateBody
          this.SendSMSwith.waterDto.id = res.data.id
        })
    },
    handleChange(value) {
      this.currentId = value
        this.$http.get(`/pipe-network/api/v1/sms/templates/${this.currentId}`).then((res) => {
          this.SendSMSwith.userDto.body = res.data.templateBody
          this.SendSMSwith.userDto.id = res.data.id
        })
    },
    SendSMSinbulkOk() {
      if (this.sendSMSLoading) return
      this.$refs.SendSMSwith.validate((valid) => {
        if (valid) {
          this.sendSMSLoading = true
          this.$http
            .post('/pipe-network/gis_class_user_water_meters/influence/note', { ...this.SendSMSwith })
            .then((res) => {
              if (res.code == 0) {
                this.selectedRows = []
                this.SendSMSwith.gisClassIds = []
                this.visibles = false
                this.visible = false
                this.SendSMSwith.userDto.body = ''
                this.SendSMSwith.waterDto.body = ''
                this.$refs.SendSMSwith.resetFields()
                return this.$message.success('发送成功！')
              } else {
                this.selectedRows = []
                this.SendSMSwith.gisClassIds = []
                this.visibles = false
                this.visible = false
                this.SendSMSwith.userDto.body = ''
                this.SendSMSwith.waterDto.body = ''
                this.$refs.SendSMSwith.resetFields()
                return this.$message.info('发送失败！')
              }
            })
            .finally(() => {
              this.sendSMSLoading = false
            })
        }
      })
    },
    SendSMSinbulkCancelh() {
      this.selectedRows = []
      this.SendSMSwith.gisClassIds = []
      this.visibles = false
      this.visible = false
      this.SendSMSwith.userDto.body = ''
      this.SendSMSwith.waterDto.body = ''
      ;(this.isUser = true), (this.isWater = true), this.$refs.SendSMSwith.resetFields()
    },
    // 导出
    exportHandle() {
      this.exportLoading = true
      const token = storage.get(ACCESS_TOKEN)
      const params = {
        responseType: 'arraybuffer',
        params: {
          analyzeData: true,
          classNos: this.id,
          // geophysicalPointNumber: 'JS581',
          page: this.pagination.current,
          limit: this.pagination.pageSize
        },
        headers: {
          Authorization: token
        }
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`
      axios
        .get(url, params)
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
          const fileName = this.exportFileName || '导出数据.xlsx'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
    pageChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getDataList()
    },
    edit(id, pipeLineLayerId) {
      this.SendSMSwith.classNos = id
      this.SendSMSwith.lineId = pipeLineLayerId
      this.showTubeView = true
      if (id) {
        this.id = id
        this.getDataList()
        this.$nextTick(() => {
          this.pagination.current = 1
        })
      }
    },
    // 跳转到对应阀门
    jumpFather(record) {
      this.closeTubeView()
      this.$emit('jumpFather', record)
    },
    // 获取数据
    getDataList() {
      this.dataListLoading = true
      const params = {
        classNos: this.id,
        // geophysicalPointNumber: 'JS581',
        page: this.pagination.current,
        limit: this.pagination.pageSize
      }
      this.$http
        .post('/pipe-network/gis_class_user_water_meters/incidence/user', params)
        .then(({ data }) => {
          this.dataListLoading = false
          this.dataList = data.list || []
          this.pagination.total = data.total ? parseInt(data.total) : 0

          /*   this.checkedList = this.dataList
                    for (let i = 0; i < this.checkedList.length; i++) {
                        this.checkedList[i].chosed = false
                    } */
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    closeTubeView() {
      this.showTubeView = false
    },
    // 收起受影响用户
    closeaffect() {
      this.$parent.affectshow = false
    },
    /**
     * 点击复制方法
     */
    copyUrl(val) {
      // 模拟 输入框
      var cInput = document.createElement('input')
      cInput.value = val

      document.body.appendChild(cInput)
      cInput.select() // 选取文本框内容

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效

      document.execCommand('copy', false)

      this.$message.info('复制成功')
      // 复制成功后再将构造的标签 移除
      document.body.removeChild(cInput)
    },
    endmessages() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要发送的短信')
      } else {
        this.SendSMSwith.gisClassIds = this.selectedRows
        this.SendSMSwithoneclick()
      }
    },
    onChange(id) {
      this.selectedRows.push(id)
      this.checkAll = this.checkedList.length === this.dataList.length
    },
    onCheckAllChange(e) {
      console.log(e)
      Object.assign(this, {
        checkedList: e.target.checked ? this.dataList : [],
        checkAll: e.target.checked
      })

      /*               for(let i =0 ; i<this.checkedList.length;i++){
                //let sub = this.dataList[i]
                this.checkedList[i].chosed=!e.target.checked
                //this.dataList[i]=sub

            } */
    }
  }
}
</script>

<style lang="less" scoped>
.head {
  width: 100%;
  height: 5vh;
  line-height: 5vh;
  background-color: rgb(44, 132, 248);
  font-size: 20px;
  font-weight: bolder;
  text-align: center;
  color: #fff;
  position: relative;

  .backicon {
    width: 25px;
    height: 25px;
    position: absolute;
    left: 1vw;
    top: 1vh;
  }
}

.cent {
  width: 100%;
  height: 90vh;
  background-color: rgb(241, 242, 246);
  overflow: auto;
  position: relative;

  .checkall {
    margin-top: 2vh;
    margin-left: 5vw;
  }

  ul {
    padding: 3vw;
    position: relative;

    li {
      background-color: #fff;
      height: 10vh;
      margin-top: 1vh;
      padding: 1%;
      position: relative;

      .checkbox {
        position: absolute;
        top: 0.6vh;
        left: 3vw;
      }

      .nikename {
        position: absolute;
        font-size: 18px;
        font-weight: bolder;
        left: 10vw;
      }

      .classno {
        position: absolute;
        top: 4vh;
        left: 10vw;
        font-size: 14px;

        .copyicon {
          width: 15px;
          height: 15px;
        }
      }

      .address {
        position: absolute;
        top: 6.5vh;
        left: 10vw;
        font-size: 14px;
      }

      .appearance {
        position: absolute;
        top: 1vh;
        right: 3vw;
        font-size: 10px;
      }
    }
  }
}

.button {
  width: 100%;
  height: 5vh;
  line-height: 5vh;
  background-color: rgb(255, 255, 255);
  text-align: center;
  color: #fff;
  position: relative;
}
</style>
